import Header from "../templates/header";
import Footer from "../templates/footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {
  faBlackboard,
  faCediSign,
  faCode,
  faPaintBrush,
  faUser,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";

const Home = () => {
  return (
    <>
      <div>
        <Header />
        <div className="d-md-flex d-block justify-content-center align-items-center mt-3  p-lg-0 p-3">
          <div className="col-lg-4 col-md-6 col-sm-12 d-md-flex d-sm-block d-block align-items-end justify-content-end">
            <img
              className="rounded mx-lg-5"
              src="/images/cover.jpg"
              width="100%"
              height="300px"
              alt="cover"
              style={{ objectFit: "cover" }}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 p-3">
            <h2 style={{ color: "yellowgreen" }}>
              We Are Web Developers, Designers And Instructors.
            </h2>
            <p>
              Our job is to create world class applications, re-design existing
              ones and implement them. We also provide world class designs to
              meet the eye. Not limited also to training we offer training on
              designing and app development.
            </p>
            <Button className="btn btn-lg btn-success">Explore now</Button>
          </div>
        </div>
        <div className="d-md-flex d-sm-block d-block flex-reverse justify-content-center align-items-center mt-5 pt-lg-5  p-lg-0 p-3">
          <div className="d-md-block d-lg-none">
            <img
              className="rounded"
              src="/images/infants.jpg"
              width="100%"
              height="300px"
              alt="cover"
              style={{ objectFit: "cover" }}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 p-3">
            <h2 style={{ color: "yellowgreen" }}>Coding For Kids.</h2>
            <p>
              Give your child an opportunity to tech at an early stage when they
              grow up to shine and have a big future.
            </p>
            <Button className="btn btn-lg btn-success">Explore now</Button>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 d-lg-block d-none">
            <img
              className="rounded"
              src="/images/infants.jpg"
              width="100%"
              height="300px"
              alt="cover"
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
        <div className="d-md-flex d-sm-block d-block justify-content-center align-items-center mt-5 pt-lg-5 p-lg-0 p-3">
          <div className="col-lg-4 col-md-6 col-sm-12 d-md-flex d-sm-block d-block align-items-end justify-content-end">
            <img
              className="rounded mx-lg-5"
              src="/images/zoom.jpg"
              width="100%"
              height="300px"
              alt="cover"
              style={{ objectFit: "cover" }}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 p-3">
            <h2 style={{ color: "yellowgreen" }}>
              Learn And Interact with Us One On One Remotely.
            </h2>
            <p>
              We do online training on various skills related to what we do,
              Take the change and explore it
            </p>
            <Button className="btn btn-lg btn-success">Explore now</Button>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-5">
          <div className="col-12 col-lg-5 p-lg-0 p-3">
            <h2 className="text-center p-3" style={{ color: "yellowgreen" }}>
              What inspired Us
            </h2>
            <p>
              <b>Change. </b>The world is evolving and new technologies arise
              meaning old ones are being taken off, So the idea for change was
              needed so we came up with the name pseudo meaning code which is
              written down. Now we are writing things down and doing them.
            </p>
          </div>
        </div>
        <div className="mt-5 d-flex justify-content-center align-items-center">
          <div className="col-12">
            <div className="d-flex justify-content-center align-items-center">
              <h2 className="text-center p-3" style={{ color: "yellowgreen" }}>
                Meet the team
              </h2>
            </div>
            <div className="d-flex justify-content-center align-items-center mb-5 pb-4">
              <div className="d-lg-flex d-block justify-content-around align-items-center text-center col-lg-9 col-md-12">
                <div
                  className="d-flex flex-column justify-content-center align-items-center border border-secondary rounded mb-5"
                  style={{ width: "270px", height: "250px" }}
                >
                  <h1 className="text-center">
                    <FontAwesomeIcon icon={faCode} />
                  </h1>
                  <h5>Jongie Bulala</h5>
                  <p style={{ color: "green" }}>
                    Software developer / Instructor
                  </p>
                  <span className="text-muted">Based in Zimbabwe</span>
                </div>
                <div
                  className="d-flex flex-column justify-content-center align-items-center border border-secondary rounded mb-5"
                  style={{ width: "270px", height: "250px" }}
                >
                  <h1 className="text-center">
                    <FontAwesomeIcon icon={faPaintBrush} />
                  </h1>
                  <h5>Leeroy Bulala</h5>
                  <p style={{ color: "green" }}>
                    Graphic designer / Instructor
                  </p>
                  <span className="text-muted">Based in Dubai</span>
                </div>
                <div
                  className="d-flex flex-column justify-content-center align-items-center border border-secondary rounded mb-5"
                  style={{ width: "270px", height: "250px" }}
                >
                  <h1 className="text-center">
                    <FontAwesomeIcon icon={faBlackboard} />
                  </h1>
                  <h5>Tafadzwa Chifamba</h5>
                  <p style={{ color: "green" }}>Product Designer</p>
                  <span className="text-muted">Based in Zimbabwe</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Home;
